<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/affiliate/dashboardAffiliate")
          i.nav-icon.cui-dashboard
          span.ml-1 {{ $t("ui.dashboard_affiliate") }}
  div.row
    div.col-md-12
      div.card
        //- div.card-header
        div.card-body
          //- div.row.mb-3
          //-   div.col-sm-12.col-md-12.col-lg-12
          //-     div
          //-       div.animated.fadeIn.col-12(style="background: white;")
          //-         line-chart(:chartData="secondDataSet" :options="chartOptions")
          //-   div.col-sm-12.col-md-6.col-lg-6
          //-     div
          //-       div.animated.fadeIn.col-12(style="background: white;")
          //-         line-chart(:chartData="firstDataSet" :options="chartOptions")
          div.row.mb-2.text-uppercase
            div.col-md-10.mb-1
              div(width="30%").mr-3
                DateRangePicker(:value="dateRange" @update="getData")
          div.row
            div.col-sm-12.col-md-6.col-lg-6
              div.row
                div.col-sm-12.col-md-4.col-lg-4
                  div.card.card-accent-success
                    div.card-header
                      i.fas.fa-money-bill-alt
                      span.font-weight-bold(:title="$t('ui.settlement')") {{ $t("ui.settlement") }}
                      //- span.badge.badge-info.float-right {{ currentMonth }}
                    div.card-body
                      div
                        div.text-value
                          h1(:class="$helpers.fontClassName(totalSettlement)" :title="$n(totalSettlement, 'currency')") {{ $n(totalSettlement, 'currency') }}
                div.col-sm-12.col-md-4.col-lg-4
                  div.card.card-accent-success
                    div.card-header
                      i.fas.fa-money-bill-alt
                      span.font-weight-bold(:title="$t('ui.deposit')") {{ $t("ui.deposit") }}
                      //- span.badge.badge-info.float-right {{ currentMonth }}
                    div.card-body
                      div
                        div.text-value
                          h1(:class="$helpers.fontClassName(totalDeposit)" :title="$n(totalDeposit, 'currency')") {{ $n(totalDeposit, 'currency') }}
                div.col-sm-12.col-md-4.col-lg-4
                  div.card.card-accent-danger
                    div.card-header
                      i.fas.fa-coins
                      span.font-weight-bold(:title="$t('ui.withdrawal')") {{ $t("ui.withdrawal") }}
                      //- span.badge.badge-info.float-right {{ currentMonth }}
                    div.card-body
                      div
                        div.text-value
                          h1(:class="$helpers.fontClassName(totalWithdrawal)" :title="$n(totalWithdrawal, 'currency')") {{ $n(totalWithdrawal, 'currency') }}
                        div.text-uppercase.text-muted(:title="$n(totalWithdrawalCount, 'integer')") {{ $t("ui.withdrawal_count") }} : {{ $n(totalWithdrawalCount, 'integer') }}
                div.col-sm-12.col-md-4.col-lg-4
                  div.card.card-accent-info
                    div.card-header
                      i.fas.fa-users
                      span.font-weight-bold(:title="$t('ui.active_player')") {{ $t("ui.active_player") }}
                      //- span.badge.badge-info.float-right {{ currentMonth }}
                    div.card-body
                      div
                        div.text-value
                          h1(:class="$helpers.fontClassName(totalActivePlayer)" :title="$n(totalActivePlayer, 'integer')") {{ $n(totalActivePlayer, 'integer') }}
                        //- div.text-uppercase.text-muted(:title="$n(totalBetCount, 'integer')") {{ $t("ui.bet_count") }} : {{ $n(totalBetCount, 'integer') }}
                div.col-sm-12.col-md-4.col-lg-4
                  div.card.card-accent-warning
                    div.card-header
                      i.fas.fa-money-bill-wave
                      span.font-weight-bold(:title="$t('ui.winlose')") {{ $t("ui.winlose") }}
                      //- span.badge.badge-info.float-right {{ currentMonth }}
                    div.card-body
                      div
                        div.text-value
                          h1(:class="$helpers.fontClassName(totalWinlose)" :title="$n(totalWinlose, 'currency')") {{ $n(totalWinlose, 'currency') }}
                div.col-sm-12.col-md-4.col-lg-4
                  div.card.card-accent-warning
                    div.card-header
                      i.fas.fa-dollar-sign
                      span.font-weight-bold(:title="$t('ui.turnover')") {{ $t("ui.turnover") }}
                      //- span.badge.badge-info.float-right {{ currentMonth }}
                    div.card-body
                      div
                        div.text-value
                          h1(:class="$helpers.fontClassName(totalValidTurnover)" :title="$n(totalValidTurnover, 'currency')") {{ $n(totalValidTurnover, 'currency') }}
                div.col-sm-12.col-md-4.col-lg-4
                  div.card.card-accent-warning
                    div.card-header
                      i.fas.fa-users
                      span.font-weight-bold(:title="$t('ui.total_member')") {{ $t("ui.total_member") }}
                      //- //- span.badge.badge-info.float-right {{ currentMonth }}
                    div.card-body
                      div
                        div.text-value
                          h1(:class="$helpers.fontClassName(totalMemberCount)" :title="$n(totalMemberCount, 'integer')") {{ $n(totalMemberCount, 'integer') }}
                div.col-sm-12.col-md-4.col-lg-4
                  div.card.card-accent-success
                    div.card-header
                      i.fas.fa-user
                      span.font-weight-bold(:title="$t('ui.total_agent')") {{ $t("ui.total_agent") }}
                      //- span.badge.badge-info.float-right {{ currentMonth }}
                    div.card-body
                      div
                        div.text-value
                          h1(:class="$helpers.fontClassName(totalAgentCount)" :title="$n(totalAgentCount, 'integer')") {{ $n(totalAgentCount, 'integer') }}
                div.col-sm-12.col-md-4.col-lg-4
                  div.card.card-accent-danger
                    div.card-header
                      i.fas.fa-pen
                      span.font-weight-bold(:title="$t('ui.verified_signup')") {{ $t("ui.verified_signup") }}
                      //- span.badge.badge-info.float-right {{ currentMonth }}
                    div.card-body
                      div
                        div.text-value.row.col-sm-12
                          h1(:class="$helpers.fontClassName(totalVerifiedCount)" :title="$n(totalVerifiedCount, 'integer')") {{ $n(totalVerifiedCount, 'integer') }}
                          h1 &nbsp;/&nbsp;
                          h1(:class="$helpers.fontClassName(totalSignupCount)" :title="$n(totalSignupCount, 'integer')") {{ $n(totalSignupCount, 'integer') }}
                div.col-sm-12.col-md-4.col-lg-4
                  div.card.card-accent-info
                    div.card-header
                      i.fa.fa-calendar
                      span.font-weight-bold(:title="$t('ui.ftd')") {{ $t("ui.ftd") }}
                      //- span.badge.badge-info.float-right {{ currentMonth }}
                    div.card-body
                      div
                        div.text-value
                          h1(:class="$helpers.fontClassName(totalFtd)" :title="$n(totalFtd, 'currency')") {{ $n(totalFtd, 'currency') }}
                        div.text-uppercase.text-muted(:title="$n(totalFtdCount, 'integer')") {{ $t("ui.ftd_count") }} : {{ $n(totalFtdCount, 'integer') }}
            div.col-sm-12.col-md-6.col-lg-6
              div.row
                div.col-sm-12.col-md-12.col-lg-12
                  div.card.card-accent-info
                    div.card-header
                      i.fas.fa-list-ol
                      span.font-weight-bold(:title="$t('ui.top_turnover')") {{ $t("ui.top_turnover") }}
                      //- span.badge.badge-info.float-right {{ currentMonth }}
                    div.card-body
                      table.table(width="100%" v-columns-resizable)
                        thead
                          tr
                            th(width="15%")
                              span #
                            th(width="30%")
                              span(:title="$t('ui.account_id')") {{ $t("ui.account_id") }}
                            th(width="30%")
                              span(:title="$t('ui.affiliate_id')") {{ $t("ui.affiliate_id") }}
                            th(width="25%")
                              span(:title="$t('ui.valid_turnover')") {{ $t("ui.valid_turnover") }}
                        tbody
                          tr(v-if="topTurnoverList.length == 0")
                            td(colspan="4").text-center
                              span {{ $t('message.no_data_available') }}
                          tr(v-for="(item, index) in topTurnoverList")
                            td
                              span {{ index + 1 }}
                            td
                              span(:title="item.account_id") {{ item.account_id }}
                            td
                              span(:title="item.affiliate_id") {{ item.affiliate_id }}
                            td
                              span(:title="$n(item.valid_turnover, 'currency')") {{ $n(item.valid_turnover, 'currency') }}
              div.row
                div.col-sm-12.col-md-12.col-lg-12
                  div.card.card-accent-danger
                    div.card-header
                      i.fas.fa-list-ol
                      span.font-weight-bold(:title="$t('ui.top_loser')") {{ $t("ui.top_loser") }}
                      //- span.badge.badge-info.float-right {{ currentMonth }}
                    div.card-body
                      table.table(width="100%")
                        thead
                          tr
                            th(width="15%")
                              span #
                            th(width="30%")
                              span(:title="$t('ui.account_id')") {{ $t("ui.account_id") }}
                            th(width="30%")
                              span(:title="$t('ui.affiliate_id')") {{ $t("ui.affiliate_id") }}
                            th(width="25%")
                              span(:title="$t('ui.loser')") {{ $t("ui.loser") }}
                        tbody
                          tr(v-if="topLoserList.length == 0")
                            td(colspan="4").text-center
                              span {{ $t('message.no_data_available') }}
                          tr(v-for="(item, index) in topLoserList")
                            td
                              span {{ index + 1 }}
                            td
                              span(:title="item.account_id") {{ item.account_id }}
                            td
                              span(:title="item.affiliate_id") {{ item.affiliate_id }}
                            td
                              span(:title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import LineChart from '@/lineChart.js';
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css';

export default {
  components: {
    SubmitButton,
    DebounceInput,
    LineChart,
    DateRangePicker
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    grandTotalSettlement: null,
    grandTotalDepositCount: null,
    grandTotalValidTurnover: null,
    grandTotalWinlose: null,
    grandTotalWithdrawal: null,
    grandTotalWithdrawalCount: null,
    grandTotalMemberCount: null,
    grandTotalActivePlayer: null,
    grandTotalBetCount: null,
    grandTotalAgentCount: null,
    grandTotalSignupCount: null,
    grandTotalVerifiedCount: null,
    grandTotalFtdCount: null,
    grandTotalFtd: null,
    grandTotalDeposit: null,
    grandTotalWithdrawal: null,
    topTurnoverList: [],
    topLoserList: [],
    firstDataSet: null,
    secondDataSet: null,
    chartOptions: {
      responsive: true,
      maintainAspectRatio: false
    },
    dateLabel: [],
    // depositList: [],
    // validTurnoverList: [],
    winloseList: [],
    withdrawalList: [],
    dateRange: {
      startDate: null,
      endDate: null,
    },
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    totalSettlement() {
      return this.grandTotalSettlement;
    },
    totalValidTurnover() {
      return this.grandTotalValidTurnover;
    },
    totalWinlose() {
      return this.grandTotalWinlose;
    },
    totalWithdrawalCount() {
      return this.grandTotalWithdrawalCount;
    },
    totalMemberCount() {
      return this.grandTotalMemberCount;
    },
    totalActivePlayer() {
      return this.grandTotalActivePlayer;
    },
    totalBetCount() {
      return this.grandTotalBetCount;
    },
    totalAgentCount() {
      return this.grandTotalAgentCount;
    },
    totalSignupCount() {
      return this.grandTotalSignupCount;
    },
    totalVerifiedCount() {
      return this.grandTotalVerifiedCount;
    },
    totalFtdCount() {
      return this.grandTotalFtdCount;
    },
    totalFtd() {
      return this.grandTotalFtd;
    },
    totalDeposit() {
      return this.grandTotalDeposit;
    },
    totalWithdrawal() {
      return this.grandTotalWithdrawal;
    },
    currentMonth() {
      return this.$moment(new Date).format("MMMM");
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
  },
  mounted: function() {
    this.dateRange.startDate = this.$moment(new Date).startOf("month").format("YYYY-MM-DD");
    this.dateRange.endDate = this.$moment(new Date).format("YYYY-MM-DD");
    this.getDashboard();
  },
  methods: {
    showActionButton(action) {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          var roles = this.$store.getters.accountAuthority[0].authority_option;
          roles =  roles && roles.length > 0 ? roles.split(',') : [];
          if (roles.includes(action))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        return true;
      }
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getDashboard();
    },
    getDashboard: function() {
      if (this.checkDateRange()) {
        let url = config.dashboardAffUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          account_id: this.$store.getters.accountId,
          // start_date: this.$moment(new Date).startOf("month").format("YYYY-MM-DD"),
          // end_date: this.$moment(new Date).format("YYYY-MM-DD")
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;

                if (this.feedback.success == true) {
                  if(response.data.ds.info.length > 0) {
                    var datatable = response.data.ds.info;
                    // for (var i = datatable.length - 1; i >= 0 ; i--) {
                    //   this.dateLabel.push(this.$moment(datatable[i]["working_date"]).format("DD"));
                    //   this.winloseList.push(datatable[i]["winlose"]);
                    //   this.withdrawalList.push(datatable[i]["withdrawal_amount"]);
                    // }

                    if(response.data.ds.info.length > 0) {
                      this.grandTotalSettlement = response.data.ds.info[0]["settlement"];
                      this.grandTotalWithdrawal = response.data.ds.info[0]["withdrawal_amount"];
                      this.grandTotalWithdrawalCount = response.data.ds.info[0]["withdrawal_count"];
                      this.grandTotalValidTurnover = response.data.ds.info[0]["valid_turnover"];
                      this.grandTotalWinlose = response.data.ds.info[0]["winlose"];
                      this.grandTotalFtd = response.data.ds.info[0]["ftd_amount"];
                      this.grandTotalFtdCount = response.data.ds.info[0]["ftd_count"];
                      this.grandTotalSignupCount = response.data.ds.info[0]["signup_count"];
                      this.grandTotalVerifiedCount = response.data.ds.info[0]["verified_count"];
                      this.grandTotalActivePlayer = response.data.ds.info[0]["active_player"];
                    }

                    this.integrateChartData();

                  }

                  if (response.data.ds.agent_count.length > 0) {
                    this.grandTotalAgentCount = response.data.ds.agent_count.length > 0 ? response.data.ds.agent_count[0].agent_count : 0;
                  }

                  if (response.data.ds.member_count.length > 0) {
                    this.grandTotalMemberCount = response.data.ds.member_count.length > 0 ? response.data.ds.member_count[0].member_count : 0;
                  }

                  if (response.data.ds.top_turnover.length > 0) {
                    this.topTurnoverList = response.data.ds.top_turnover;
                  }

                  if (response.data.ds.top_loser.length > 0) {
                    this.topLoserList = response.data.ds.top_loser;
                  }

                  if (response.data.ds.deposit.length > 0) {
                    this.grandTotalDeposit = response.data.ds.deposit.length > 0 ? response.data.ds.deposit[0].deposit_amount : 0;
                  }

                  if (response.data.ds.withdrawal.length > 0) {
                    this.grandTotalWithdrawal = response.data.ds.withdrawal.length > 0 ? response.data.ds.withdrawal[0].withdrawal_amount : 0;
                  }
                } else {
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    redirectTo: function(link) {
      this.$router.push(link);
    },
    integrateChartData: function () {
      this.secondDataSet = {
        labels: this.dateLabel,
        datasets: [
          {
            label: this.$t("ui.winlose"),
            backgroundColor: '#FFF176',
            data: this.winloseList
          },
          {
            label: this.$t("ui.withdrawal"),
            backgroundColor: '#FFB74D',
            data: this.withdrawalList
          }
        ]
      };
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss">

.badge {
  padding: 2.5px 4px !important;
}
.text-value {
  h1 {
    overflow:hidden !important;
    text-overflow:ellipsis !important;
    white-space: nowrap !important;
  }
}
</style>